import Templates from "@/views/Templates.vue";
import ActivityFeed from "@/views/ActivityFeed.vue";
import { getTemplateRoutes } from "@26lights/orcha";
import { RouteRecordRaw } from "vue-router";

const templateBaseRoute = {
  component: Templates,
  meta: { requiresAuth: true, requiresAdmin: true },
};
const templateRoutes = getTemplateRoutes("/templates", templateBaseRoute);

const activityFeedRoute: RouteRecordRaw = {
  path: "/activity-feed/:id?/:slug?",
  name: "ActivityFeed",
  component: ActivityFeed,
  props: (route) => ({
    initialActivityId: route.params.id,
    initialActivitySlug: route.params.slug,
    feedMode: "standard",
  }),
  meta: { requiresAuth: true },
};

const activityFeedDevRoute: RouteRecordRaw = {
  path: "/activity-feed-dev/:id?/:slug?",
  name: "ActivityFeedDev",
  component: ActivityFeed,
  props: (route) => ({
    initialActivityId: route.params.id,
    initialActivitySlug: route.params.slug,
    feedMode: "dev",
  }),
  meta: { requiresAuth: true },
};

export default [...templateRoutes, activityFeedRoute, activityFeedDevRoute];
